<template>
  <img class="agent-photo" v-if="preferences.author.agent_photo" :src="photoSrc" :alt="preferences.author.name" />
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AgentLogo',
  computed: {
    photoSrc () {
      return `${process.env.VUE_APP_API_DOMAIN}${this.preferences.author.agent_photo}?token=${this.token}&t=${this.timestamp}`
    },
    ...mapState({
      token: state => state.report.token,
      timestamp: state => state.report.timestamp,
    }),
  },
}
</script>

<style lang="scss" scoped>
  .agent-photo {
    position: relative;
    float: left;
    max-width: 60px;
    margin-top: 5px;
    margin-right: 10px;
  }
</style>
